import { useMemo } from 'react';
import { isFormValid, isCurrentProductFree, isCostPoolRequired } from 'utils/validation';

/**
 * Custom hook for resource form validation
 */
export const useResourceValidation = ({
  formData,
  mode,
  isDevTenant,
  isSelectedTenantPartner,
  isDevResource,
  products,
  prices = []
}) => {
  // Memoize validation functions to avoid recreating on every render
  const isCurrentProductFreeFn = useMemo(() => {
    return () => isCurrentProductFree(formData, isDevResource);
  }, [formData, isDevResource]);

  const isCostPoolRequiredFn = useMemo(() => {
    return () => isCostPoolRequired(formData, products, prices);
  }, [formData, products, prices]);

  const isFormValidFn = useMemo(() => {
    return () => isFormValid(
      formData,
      mode,
      isDevTenant,
      isSelectedTenantPartner,
      isDevResource,
      isCurrentProductFreeFn
    );
  }, [formData, mode, isDevTenant, isSelectedTenantPartner, isDevResource, isCurrentProductFreeFn]);

  return {
    isCurrentProductFree: isCurrentProductFreeFn,
    isCostPoolRequired: isCostPoolRequiredFn,
    isFormValid: isFormValidFn
  };
};

